import React from 'react';
import { isChunkLoadError } from '../utils/lazyWithRetry';

/**
 * Shown when a lazy route chunk fails after the one automatic reload
 * (typically a tab left open across a deploy).
 */
class ChunkLoadErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    const { error } = this.state;
    if (!error) {
      return this.props.children;
    }

    if (isChunkLoadError(error)) {
      return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-gray-50">
          <div className="max-w-md text-center">
            <h1 className="text-xl font-bold text-gray-900 mb-2">Update available, reload</h1>
            <p className="text-gray-600 mb-4">
              A new version of Fixome is ready. Reload the page to continue.
            </p>
            <button type="button" className="fx-btn-primary" onClick={this.handleReload}>
              Reload
            </button>
          </div>
        </div>
      );
    }

    return (
      <div className="min-h-screen flex items-center justify-center p-6 bg-gray-50">
        <div className="max-w-md text-center">
          <h1 className="text-xl font-bold text-gray-900 mb-2">Something went wrong</h1>
          <p className="text-gray-600 mb-4">Reload the page to try again.</p>
          <button type="button" className="fx-btn-primary" onClick={this.handleReload}>
            Reload
          </button>
        </div>
      </div>
    );
  }
}

export default ChunkLoadErrorBoundary;
